import { IconButton, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { WorkgroupGroupRow } from '../../list';
import { WorkgroupGroupsViewModal } from '../WorkgroupGroupsViewModal';

interface WorkgroupGroupProps {
  workgroupGroup: WorkgroupGroupRow;
}

export const EditWorkgroupGroup: React.FC<WorkgroupGroupProps> = ({
  workgroupGroup,
}) => {
  const [visible, setVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { _isUpdatable } = { ...workgroupGroup };

  const _onClick = () => {
    setVisible(true);
    setIsEdit(true);
  };

  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={_onClick}
        disabled={!_isUpdatable}
      />
      <WorkgroupGroupsViewModal
        isOpen={visible}
        isEdit={isEdit}
        workgroupGroup={workgroupGroup}
        onClose={() => setVisible(false)}
      />
    </Stack>
  );
};
